export enum CIOObjectType {
	STUDY = '1',
	DISCIPLINE = '2',
	COUNTRY = '3',
	ORGANISATION = '5'
}
